<template>
  <div
    class="index-v3-bg"
    :style="{
      backgroundImage: `url(${$store.state.OPTIONS._app_background})`,
    }"
  >
    <v-container class="index-v3">
      <h1 class="text-h2 white--text">{{ $store.state.OPTIONS._app_title }}</h1>
      <p class="text-h5 white--text">{{ $store.state.OPTIONS._app_subtitle }}</p>
      <v-divider style="width: 100%" dark></v-divider>
      <v-row style="flex: none">
        <v-col v-for="item of btns" :key="item.name">
          <v-btn
            rounded
            color="primary"
            dark
            large
            v-if="
              /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(
                item.path
              )
            "
            :href="item.path"
            >{{ item.name }}</v-btn
          >
          <v-btn rounded color="primary" dark large v-else :to="item.path">{{
            item.name
          }}</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import mjp from "@/plugins/makjust";
export default {
  data() {
    return {
      btns: [
        {
          name: "用户中心",
          path: "/user",
        },
        {
          name: "皮肤库",
          path: "/skin",
        },
        {
          name: "进群吹水",
          path: "https://jq.qq.com/?_wv=1027&k=5Knocti",
        },
      ],
    };
  },
  mounted() {
    //set scroll.
    // this.smoothScroll(0)
    // this.$nextTick(()=>{
    //   window.addEventListener("scroll", this.setScroll);
    // })
    //get banner
    // mjp.getBanner().then((banner) => {
    //   this.slides = banner.data.results;
    // });
    ///TIP: 此处注释为暂时下架的MCBBS新闻获取。
    // mjp.getNewsAsync().then(news => {
    //   if (Array.isArray(news.data)) {
    //     this.newsList = news.data;
    //     this.newsLoading = true;
    //   } else {
    //     this.newsLoading = false;
    //   }
    // });
    // mjp.getAnnouncements().then((ann) => {
    //   if (!ann.code) {
    //     let _ann = ann.data.results;
    //     _ann.sort((a, b) => {
    //       return new Date().getTime(a.createdAt) >
    //         new Date().getTime(b.createdAt)
    //         ? 1
    //         : -1;
    //     });
    //     this.accList = _ann;
    //     this.accLoading = false;
    //   }
    // });
  },
};
</script>

<style>
.index-v3 {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.index-v3-bg{
  height: 100%;
  width: 100%;
  background-color: #cccccc;
  background-position: top;
  background-size: cover;
}
.index-banner {
  position: relative;
  height: 100vh;
  width: 100%;
  color: white;
  margin-top: -104px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  
}
.index-banner > div h1 {
  font-weight: 100;
  font-size: 3.5rem;
}
.index-banner > div p {
  font-size: 2rem;
}
.index-carousel .text {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 20%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.3), 25%, transparent);
}
.index-carousel .text > .title {
  max-width: 50%;
  text-align: center;
  padding: 0.7rem 3rem;
  margin: 1rem 0;
  background-color: rgba(15, 149, 176, 0.65);
  border-radius: 5px;
}
.index-carousel .text > .text-content {
  max-width: 80%;
  text-align: center;
  padding: 0.5rem 5rem;
  margin: 0.5rem 0;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 5px;
}
.index-banner .mouse-down-box {
  position: absolute;
  display: inherit;
  width: 100%;
  bottom: 16px;
}
.index-banner .mouse-down-box span {
  font-size: 0.4rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.index-banner .mouse-down-box > div {
  margin: 0 auto;
  display: flex;
  position: relative;
  flex-direction: column;

  width: 24px;
}
.index-banner .mouse-down-box > div .v-icon {
  position: absolute;
  transform: rotate(90deg);
  animation: 1.3s ease-in 0s infinite mouse-down-ani;
  width: 24px;
  margin: 0 auto;
}

@keyframes mouse-down-ani {
  0% {
    opacity: 0;
    top: -60px;
    transform: rotateY(360deg) rotateZ(90deg);
  }
  50% {
    opacity: 1;
    top: -42px;
    transform: rotateY(0deg) rotateZ(90deg);
  }
  100% {
    opacity: 0;
    top: -18px;
    transform: rotateX(90deg) rotateY(0deg) rotateZ(90deg);
  }
}
</style>
